import styled, { css } from "styled-components";

interface PropsContent {
  hasIcon?: boolean;
}

export const Container = styled.div``;

export const Content = styled.div<PropsContent>`
  ${({ theme, hasIcon }) => css`
    background-color: ${theme.colors.white};
    border-bottom: ${`1px solid ${theme.colors.transactionSecondary}`};
    display: flex;
    justify-content: space-between;
    align-items: center;

    input {
      padding: 0.75rem 0.5rem;
      flex: 1;
      border: none;
      background-color: initial;

      &:focus-visible {
        outline: none;
      }

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 3rem ${theme.colors.white} inset;
      }
    }

    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      margin-right: 0.5rem;
    }

    button {
      border: 0;
      margin: 0;
      background-color: transparent;
      display: ${hasIcon ? "flex" : "none"};
    }

    @media (min-width: 640px) {
      img {
        width: 23px;
        height: 23px;
      }
    }
  `}
`;
